export default __webpack_public_path__ + "static/gift-cards-9449a2361e65e158fad6bbab5982745c.jpg";